import { computed, Directive, input } from '@angular/core';

@Directive({
  selector: '[dsAriaLabelledBy]',
  host: {
    '[attr.aria-labelledby]': 'labelledBy()',
  },
})
export class AriaLabelledByDirective {
  public dsAriaLabelledBy = input.required<string | null>();

  // if null, then leave as is (since this is intentional)
  // if not null and value, then return 'labelid-<value>
  // else null (no attribute)
  protected labelledBy = computed(() =>
    this.dsAriaLabelledBy() === null ? null : this.dsAriaLabelledBy() ? `labelid-${this.dsAriaLabelledBy()}` : null,
  );
}
